export default __webpack_public_path__ + "a64bc970a96c0dc00eb284575f9e3a3b.svg";